/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WeekendVisibility_company = {
    readonly weekendDisplayPerUser: boolean | null;
    readonly weekendDisplayShowAlways: boolean | null;
    readonly createdAt: string | null;
    readonly " $refType": "WeekendVisibility_company";
};
export type WeekendVisibility_company$data = WeekendVisibility_company;
export type WeekendVisibility_company$key = {
    readonly " $data"?: WeekendVisibility_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WeekendVisibility_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WeekendVisibility_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekendDisplayPerUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekendDisplayShowAlways",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '58cbddeadcc93ca828e3924985d6f159';
export default node;
